import { useContext } from 'react';
import JwtDecode from 'jwt-decode';

import AppContext from '../components/App/AppContext';
import { setStorageTokens } from '../helpers/Auth';

const useSetUser = () => {
  const { setUser } = useContext(AppContext);

  return (rawUser) => {
    const { mail, rut, cellphone, acc } = JwtDecode(rawUser.token);
    const user = {
      ...rawUser,
      user: {
        mail,
        rut,
        cellphone,
        acc,
      },
    };

    setUser(user);

    setStorageTokens(rawUser);
  };
};

export default useSetUser;
